import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    v: hours,
    l: "Hours"
  }, {
    v: minutes,
    l: "Min"
  }, {
    v: seconds,
    l: "Sec"
  }];
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c25rrb3dm20l">
      <p className={`flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-wider ${dark ? "text-sky" : "text-skydeep"}`} data-id="element-20" data-mp="3c3yysrhwio94">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="324870xkq6ncq" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-22" data-mp="371zvtiq2ptcp">
        {units.map((u, i) => <React.Fragment key={u.l} data-id="element-23" data-mp="10del7sk599wa" data-mpi={i}>
            {i > 0 && <span className={`pt-3 font-display text-3xl font-bold ${dark ? "text-white/60" : "text-navy/50"}`} data-id="element-24" data-mp="10ailpzsned5q">:</span>}
            <div className="flex flex-col items-center" data-id="element-25" data-mp="y0ww3psrg4ml">
              <span className={`flex h-[68px] w-[68px] items-center justify-center rounded-xl font-display text-4xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${dark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-26" data-mp="xzc0rxymghno">
                {String(u.v).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-ink/55"}`} data-id="element-27" data-mp="f1ix2tg6c3p8">{u.l}</span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}